<template>
    <div class="card partner-contact-box" v-if="isActive">
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <h3 class="text-center">{{ getTitle }}</h3>
                    <p class="text-center">{{ getText }}</p>
                </div>
                <div class="col-6 offset-3 my-2">
                    <b-img :src="getImage" class="w-100" />
                </div>
                <div class="col-12">
                    <div class="text-center">
                        <p class="mb-0">{{ getName }}</p>
                        <p class="mb-0">{{ getRank }}</p>
                        <p v-if="getContactPhone" class="mb-0">{{$t('pds.partner_info.phone')}}: <a class="track-contact-person-contact-phone" :href="getContactPhoneCta">{{ getContactPhone }}</a></p>
                        <p class="mb-0">{{$t('pds.partner_info.email')}}: <a class="track-contact-person-contact-mail" :href="getContactMailCta" >{{ getContactMail }}</a></p>
                    </div>
                </div>
                <div class="col-6 offset-3 mt-3" v-if="getSubsidiaryLogo">
                    <b-img :src="getSubsidiaryLogo" class="w-100" v-if="!isLoading"/>
                    <b-skeleton-img widht="100%" v-else></b-skeleton-img>
                </div>
                <div class="col-12 mt-3 text-center" v-if="!isLoading">
                    <p><b>{{ getSubsidiary }}</b></p>
                    <p v-if="this.$root.whitelabel.isUs()">{{ getNumber }} {{ getStreet }}</p>
                    <p v-else>{{ getStreet }} {{ getNumber }}</p>
                    <p v-if="this.$root.whitelabel.isUs()">{{ getCityUS }}</p>
                    <p v-else>{{ getCity }}</p>
                </div>
                <div class="col-12 mt-3" v-else>
                    <b-skeleton width="55%" height="1rem"></b-skeleton>
                    <b-skeleton width="45%" height="1rem"></b-skeleton>
                    <b-skeleton width="50%" height="1rem"></b-skeleton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BSkeleton, BSkeletonImg, BImg } from "bootstrap-vue";
export default {
    name: 'PartnerContactBox',
    components: {
        BSkeleton, BSkeletonImg, BImg
    },
    props: {
        entry: null,
        isLoading: true
    },
    data() {
        return {}
    },
    computed: {
        getTitle(){
            return this.contactData ? this.contactData.title : ''
        },
        getText(){
            return this.contactData ? this.contactData.text : ''
        },
        getSubsidiaryLogo(){
            return this.entry ? this.entry.subsidiary.logo : ''
        },
        getImage(){
            return this.contactData ? this.contactData.image : ''
        },
        getName(){
            return this.contactData ? this.contactData.name : ''
        },
        getRank(){
            return this.contactData ? this.contactData.rank : ''
        },
        getSubsidiary(){
            return this.entry ? this.entry.subsidiary.contact.title : ''
        },
        getStreet(){
            return this.entry ? this.entry.subsidiary.contact.address.street : ''
        },
        getNumber() {
            return this.entry ? this.entry.subsidiary.contact.address.house_number : ''
        },
        getCity(){
            return this.entry.subsidiary.contact.address.postal_code && this.entry.subsidiary.contact.address.city ? `${this.entry.subsidiary.contact.address.postal_code} ${this.entry.subsidiary.contact.address.city}` : ''
        },
        getCityUS(){
            return this.entry.subsidiary.contact.address.postal_code && this.entry.subsidiary.contact.address.city ? `${this.entry.subsidiary.contact.address.city}, ${this.$t("regions." + this.entry.address.region)} ${this.entry.subsidiary.contact.address.postal_code}` : ''
        },
        getContactPhone(){
            return this.contactData ? this.contactData.phone : ''
        },
        getContactMail(){
            return this.contactData ? this.contactData.mail : ''
        },
        getContactPhoneCta(){
            return this.contactData ? `tel:${this.contactData.phone}` : ''
        },
        getContactMailCta(){
            return this.contactData ? `mailto:${this.contactData.mail}` : ''
        },
        isActive() {
            return this.contactData && this.contactData.isActive
        },
        contactData() {
            let objects = this.$root.whitelabel.state.contact_person

            let contactData = {}
            if (this.entry === null) {
                return contactData
            }
            for (let i = 0; i < objects.length; i++) {
                if (objects[i].subsidiary_uuid === this.entry.subsidiary_uuid) {
                    contactData = objects[i]
                }
            }
            return contactData
        }

    },
    mounted() {

    }
}
</script>

<style scoped>
p {
    margin-bottom: 0;
}
</style>
